import { useEffect } from "react";
import { useState } from "react";
import { getSubscriptionPaymentByDate, getMemberBirthdaysByDateRange, getMemberAnniversariesByDateRange, getMembershipTypes, getSubscriptionMasterAllByMembershipType } from "../api/paymentAPI";
import { apiUrl } from '../../axios';
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
import defaultUserImg from '../../assets/images/user.jpg'
import Select from 'react-select';

const SubscriptionPayment = (props) => {
    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().subtract(30, "days").toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [isInit,                          setIsInit]                   = useState(true);
    const [subscriptionReport,              setSubscriptionReport]       = useState([]);
    const [subscriptionTable,               setSubscriptionTable]        = useState(null);
    const [status,                          setStatus]                   = useState([{ value: 'All', label: 'All' }, { value: 'Online', label: 'Online' }, { value: 'Offline', label: 'Offline' }, { value: 'Birthday', label: 'Birthday' }, { value: 'Anniversary', label: 'Anniversary' }]);
    const [statusType,                      setStatusType]               = useState(status[0].value);
    const [birthdayList,                    setBirthdayList]             = useState([]);
    const [anniversaryList,                 setAnniversaryList]          = useState([]);
    const [membershipTypes,                 setMembershipTypes]          = useState([]);
    const [selectedMembershipType,          setSelectedMembershipType]   = useState(null);
    const [membershipPlans,                 setMembershipPlans]          = useState([]);
    const [selectedMembershipPlan,          setSelectedMembershipPlan]   = useState(null);

    useEffect(() => {
        props.title('Membership Report','subscription-payment')
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        });
        fetchMembershipTypes();
    },[])

    useEffect(() => {
        if (!isInit) {
            fillTable();
        }
    }, [subscriptionReport, birthdayList, anniversaryList]);

    useEffect(() => {
        if (statusType && !isInit) {
            if (statusType === 'Birthday') {
                fetchBirthdays();
            } else if (statusType === 'Anniversary') {
                fetchAnniversaries();
            } else {
                $('#tblSubscriptionPayment').KTDatatable().destroy();
                fillTable();
            }
        }
    },[statusType])

    useEffect(() => {
        if (selectedFromDate && selectedToDate) {
            if (statusType === 'Birthday') {
                fetchBirthdays();
            } else if (statusType === 'Anniversary') {
                fetchAnniversaries();
            } else {
                const fd = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                const td = moment(selectedToDate,   'DD-MM-YYYY').format('YYYY-MM-DD');
                fetchOrderSheet(fd, td);
            }
        }
    },[selectedFromDate, selectedToDate])

    const fetchOrderSheet = async(fdate, tDate, typeID = undefined, planID = undefined) => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const membershipTypeID   = typeID !== undefined ? typeID : (selectedMembershipType?.value  || null);
            const subscriptionMstrID = planID !== undefined ? planID : (selectedMembershipPlan?.value  || null);
            const response = await getSubscriptionPaymentByDate(fdate, tDate, membershipTypeID, subscriptionMstrID);
            isInit ? setIsInit(false) : $('#tblSubscriptionPayment').KTDatatable().destroy(); 
            setSubscriptionReport(response)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })
        }
    };

    const fetchBirthdays = async () => {
        const fdate = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        const tDate = moment(selectedToDate,   'DD-MM-YYYY').format('YYYY-MM-DD');
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const response = await getMemberBirthdaysByDateRange(fdate, tDate);
            isInit ? setIsInit(false) : $('#tblSubscriptionPayment').KTDatatable().destroy();
            setBirthdayList(response);
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    const fetchAnniversaries = async () => {
        const fdate = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        const tDate = moment(selectedToDate,   'DD-MM-YYYY').format('YYYY-MM-DD');
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const response = await getMemberAnniversariesByDateRange(fdate, tDate);
            isInit ? setIsInit(false) : $('#tblSubscriptionPayment').KTDatatable().destroy();
            setAnniversaryList(response);
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    const fetchMembershipTypes = async () => {
        try {
            const result = await getMembershipTypes();
            const options = result.map(m => ({ label: m.Name, value: m.ID }));
            setMembershipTypes(options);
        } catch (err) {
            Swal.fire({ icon: 'error', titleText: err.message });
        }
    };

    const handleMembershipTypeChange = async (selected) => {
        setSelectedMembershipType(selected);
        setSelectedMembershipPlan(null);
        setMembershipPlans([]);
        if (selectedFromDate && selectedToDate && statusType !== 'Birthday' && statusType !== 'Anniversary') {
            const fd = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            const td = moment(selectedToDate,   'DD-MM-YYYY').format('YYYY-MM-DD');
            fetchOrderSheet(fd, td, selected?.value || null, null);
        }
        if (!selected) return;
        try {
            const plans = await getSubscriptionMasterAllByMembershipType(selected.value);
            setMembershipPlans(plans.map(p => ({ label: p.Name, value: p.ID })));
        } catch (err) {
            Swal.fire({ icon: 'error', titleText: err.message });
        }
    };

    const handleMembershipPlanChange = (selected) => {
        setSelectedMembershipPlan(selected);
        if (selectedFromDate && selectedToDate && statusType !== 'Birthday' && statusType !== 'Anniversary') {
            const fd = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            const td = moment(selectedToDate,   'DD-MM-YYYY').format('YYYY-MM-DD');
            fetchOrderSheet(fd, td, selectedMembershipType?.value || null, selected?.value || null);
        }
    };

    const getExportFilename = () => {
        const date = moment().format('DD-MM-YYYY');
        if (statusType === 'Birthday')    return `${date} - Birthday List`;
        if (statusType === 'Anniversary') return `${date} - Anniversary List`;
        if (selectedMembershipType && selectedMembershipPlan) return `${date} - ${selectedMembershipType.label} - ${selectedMembershipPlan.label}`;
        if (selectedMembershipType) return `${date} - ${selectedMembershipType.label}`;
        return `${date} - Subcription Sheet`;
    };

    function exportSheet(type) {
        subscriptionTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: getExportFilename(),
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    };

    function fillTable() {
        var source;
        var columns;

        if (statusType === 'Birthday') {
            source = birthdayList;
            columns = [
                {
                    field: 'Name',
                    title: 'Member',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-profile" height="50" width="50">` : `<img src="${defaultUserImg}" alt="user-profile" height="50" width="50">`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.Name}</span>
                                    </div>
                                </div>`;
                    }
                },
                {
                    field: 'MembershipNo',
                    title: 'Membership No',
                    width: 120,
                },
                {
                    field: 'Mobile',
                    title: 'Contact',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.Mobile || ''}</span>
                                        <span class="kt-user-card-v2__desc text-clip">${row.Email || ''}</span>
                                    </div>
                                </div>`;
                    },
                    width: 180,
                },
                {
                    field: 'MembershipTypeName',
                    title: 'Membership Type',
                    width: 150,
                },
                {
                    field: 'BirthdayDisplay',
                    title: 'Birthday',
                    width: 110,
                    template: function (row) {
                        return `<strong>${row.BirthdayDisplay || ''}</strong>`;
                    }
                },
            ];
        } else if (statusType === 'Anniversary') {
            source = anniversaryList;
            columns = [
                {
                    field: 'Name',
                    title: 'Member',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-profile" height="50" width="50">` : `<img src="${defaultUserImg}" alt="user-profile" height="50" width="50">`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.Name}</span>
                                    </div>
                                </div>`;
                    }
                },
                {
                    field: 'MembershipNo',
                    title: 'Membership No',
                    width: 120,
                },
                {
                    field: 'Mobile',
                    title: 'Contact',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.Mobile || ''}</span>
                                        <span class="kt-user-card-v2__desc text-clip">${row.Email || ''}</span>
                                    </div>
                                </div>`;
                    },
                    width: 180,
                },
                {
                    field: 'MembershipTypeName',
                    title: 'Membership Type',
                    width: 150,
                },
                {
                    field: 'AnniversaryDisplay',
                    title: 'Anniversary',
                    width: 110,
                    template: function (row) {
                        return `<strong>${row.AnniversaryDisplay || ''}</strong>`;
                    }
                },
            ];
        } else {
            source = statusType === 'All'
                ? subscriptionReport.SubscriptionPaymentList
                : subscriptionReport.SubscriptionPaymentList.filter(i => i.PaymentType == statusType);
            columns = [
                {
                    field: 'FirstName',
                    title: 'Member',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                    ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-profile" height="50" width="50">` : `<img src="${defaultUserImg}" alt="user-profile" height="50" width="50">`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> <span class="kt-user-card-v2__desc text-clip"> ${row.MembershipNo} </span>
                                    </div>
                                </div>`
                    }
                }, 
                {
                    field: ' ',
                    title: 'Contact',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Mobile} </span> 
                                        <span class="kt-user-card-v2__desc text-clip"> ${row.Email} </span>
                                    </div>
                                </div>`
                    },
                    width: 180,
                },
                {
                    field: '  ',
                    title: 'Plan',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.SubscriptionName} </span> 
                                        <span class="kt-user-card-v2__desc text-clip"> ${row.Code} </span>
                                    </div>
                                </div>`
                    },
                    width: 180,
                },
                {
                    field: 'MembershipTypeName',
                    title: 'Membership Type',
                    width: 130,
                },
                {
                    field: 'BillNumber',
                    title: 'Bill Number',
                    width: 85,
                },
                {
                    field: 'Amount',
                    title: 'Bill Amount',
                    width: 100,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ₹ ${row.Amount}</strong>`
                    }
                },
                {
                    field: 'TransactionDate',
                    title: "Transaction Date",
                    width: 120,
                    template: function (row) {
                        return moment(row.TransactionDate).format('DD-MMM-YYYY');
                    }
                },
                {
                    field: 'PaymentType',
                    title: 'Type',
                    width: 80,
                    template: function (row) {
                        if (row.PaymentType == 'Online') {
                            return `<span style="width: 70px;"><div class="badge badge-label-success"><span> Online </span></div></span>`;
                        } else {
                            return `<span style="width: 70px;"><div class="badge badge-label-brand"><span> Offline </span></div></span>`;
                        }
                    }
                },
                {
                    field: 'OrderStatus',
                    title: 'Status',
                    width: 80,
                    template: function (row) {
                        if (row.OrderStatus == 'Success') {
                            return `<div><span class="btn btn-bold btn-font-sm  btn-label-success" style="padding-left: 9px"> Success</span></div>`;
                        } else {
                            return `<div><span class="btn btn-bold btn-font-sm  btn-label-danger">Fail</span></div>`;
                        }
                    }
                },
                {
                    field: 'Comment',
                    title: ' ',
                    width: 60,
                    template: function (row) {
                        const comment = row?.Comment || ''; // Get comment or empty string
                        return `<center>
                            <button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-invoice" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-content="View Receipt"><i class="fa fa-file-alt"></i></button>
                            ${row?.Comment && `&nbsp;<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover" data-trigger="hover click" data-placement="left" data-content="${comment}"><i class="fa fa-info"></i></button>`}
                            <span style="display: none;">${comment}</span>
                        </center>`;
                    }
                },
            ];
        }

        Swal.close();

        Config.Core.InitPopover();

        const dataTable = $('#tblSubscriptionPayment').KTDatatable({
            data: {
                saveState: false,
                source,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns,
            rows: {
                autoHide: false,
            }
        });

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        if (statusType !== 'Birthday' && statusType !== 'Anniversary') {
            dataTable.on('click', '.btn-invoice', function (ss) {
                const index = $(ss.currentTarget).parents('tr').index();
                if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                    window.open(`${apiUrl}/api/payment/getOrderByPaymentOrderID?paymentOrderID=${dataTable.dataSet[index].PaymentOrderID}`, '_blank', 'noreferrer');
                }
            });
        }

        // export to excel
        const subscriptionTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: statusType === 'Birthday'
                ? `${moment().format('DD-MM-YYYY')} - Birthday List`
                : statusType === 'Anniversary'
                    ? `${moment().format('DD-MM-YYYY')} - Anniversary List`
                    : `${moment().format('DD-MM-YYYY')} - Subcription Sheet`,
        });
        setSubscriptionTable(subscriptionTable);
        $('.tableexport-caption').addClass('hidden');
    };

    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group  col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div  className="col-sm-1">
                                    </div>
                                    <div className="form-group col-sm-2 pnlStatus ">
                                        <div>
                                            <Select 
                                                id="ddlStatus" 
                                                name="ddlStatus "
                                                className="multi-custom "
                                                defaultValue={ status.find((m) => m.value[0] )  || ''}
                                                onChange={(event) => setStatusType(event.value)}
                                                options={status}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search Member..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button
                                                    id="btn-export-excel"
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}
                                                > Excel
                                                </button>
                                                <button
                                                    id="btn-export-csv"
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {statusType !== 'Birthday' && statusType !== 'Anniversary' && (
                                <div className="row" style={{marginTop: '10px'}}>
                                    <label className="col-form-label col-md-2 col-xl-1 text-right">Membership Type</label>
                                    <div className="form-group col-md-3 col-xl-2">
                                        <Select
                                            id="ddlSelectMembershipType"
                                            name="ddlSelectMembershipType"
                                            className="multi-custom"
                                            placeholder="Select..."
                                            options={membershipTypes}
                                            value={selectedMembershipType}
                                            onChange={handleMembershipTypeChange}
                                            isClearable
                                        />
                                    </div>
                                    <label className="col-form-label col-md-2 col-xl-1 text-right">Membership Plan</label>
                                    <div className="form-group col-md-3 col-xl-2">
                                        <Select
                                            id="ddlSelectMembershipPlan"
                                            name="ddlSelectMembershipPlan"
                                            className="multi-custom"
                                            placeholder="Select..."
                                            options={membershipPlans}
                                            value={selectedMembershipPlan}
                                            onChange={handleMembershipPlanChange}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                )}
                                {statusType !== 'Birthday' && statusType !== 'Anniversary' && (
                                    <div className="row monthly-payemnt-amount-box" style={{color: '#535354', fontSize: '14px'}}>
                                        <label className="col-12"><span style={{fontWeight: '400'}}>Total Amount</span><strong style={{fontWeight: '600'}}> :  ₹ {subscriptionReport.Total}</strong>  </label>
                                    </div>
                                )}
                            </div>
                            <div id="tblSubscriptionPayment" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubscriptionPayment